export const classes = {
  header:
    'col-[1/-1] relative z-20 flex h-14 items-center gap-3 rounded-2xl mt-[14px] mr-[22px] mb-1 ml-[14px] pl-5 pr-1.5 bg-header-aurora shadow-header-aurora',
  spacer: 'flex-1',
  divider: 'mx-0.5 h-6 w-px bg-black/10',
  iconButton:
    'place-center size-9 rounded-xl text-taupe-2 transition-colors hover:bg-black/5',
  addButtonWrapper: 'ml-2',
  addButton:
    'place-center size-9 rounded-xl bg-orange-2/[0.15] text-orange-2 transition-colors hover:bg-orange-2/25',
  testingWrapper: 'text-orange-2 border border-orange-1 py-1 px-4 rounded-md',
  testingLink: 'ml-2 underline cursor-pointer font-medium',
};
